import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { GradingMonitoringDto } from './grading-monitoring.dto';

export class AllGradingMonitoringResponseModel extends GlobalResponseObject{
    data?: GradingMonitoringDto[];
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data //GradingMonitoringDto[]
     */
     constructor(status: boolean, intlCode: number, internalMessage: string, data?: GradingMonitoringDto[]) {
        super(status, intlCode, internalMessage);
        this.data = data;
    }    
}
